export const static_options = {
  source: [
    { value: 1, label: '校友推荐' },
    { value: 2, label: '招生活动' },
    { value: 3, label: '班主任点招' },
    { value: 4, label: '兔必点招' },
    { value: 5, label: '共学中心点招' },
    { value: 6, label: '主动报名-校区' },
    { value: 7, label: '主动报名-总部' },
    { value: 8, label: '其他' }
  ],
  status: [
    { value: 1, label: '待约面试' },
    { value: 3, label: '待面试' },
    { value: 4, label: '待录取' },
    { value: 5, label: '待缴费' },
    { value: 7, label: '已缴费' },
    { value: 6, label: '不缴费' },
    { value: 2, label: '无效' }
  ],
  fee_channel: [
    { value: 1, label: '总部' },
    { value: 2, label: '校区' }
  ],
  undelivered_module: [
    { value: 1, label: '开学典礼' },
    { value: 2, label: '一模块' },
    { value: 3, label: '二模块' },
    { value: 4, label: '三模块' },
    { value: 5, label: '私董会' }
  ],
  cloth_size: [
    { value: 'S', label: 'S' },
    { value: 'M', label: 'M' },
    { value: 'L', label: 'L' },
    { value: 'XL', label: 'XL' },
    { value: '2XL', label: '2XL' },
    { value: '3XL', label: '3XL' },
    { value: '4XL', label: '4XL' },
    { value: '5XL', label: '5XL' }
  ],
  gender: [
    { value: 1, label: '男' },
    { value: 2, label: '女' }
  ],
  online_status: [
    { value: 1, label: '在籍' },
    { value: 2, label: '体验学籍' },
    { value: 3, label: '过期' },
    { value: 5, label: '注册' },    
    { value: 4, label: '无' }
  ]
};
